import { render, staticRenderFns } from "./detailInvoice.vue?vue&type=template&id=0cc60e0b"
import script from "./detailInvoice.vue?vue&type=script&lang=js"
export * from "./detailInvoice.vue?vue&type=script&lang=js"
import style0 from "./detailInvoice.vue?vue&type=style&index=0&id=0cc60e0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports